package org.example.project.service

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import kotlinx.coroutines.await

@Composable
fun rememberActiveBuildName(): String {
    var buildName by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        buildName = runCatching {
            // /node/status reports the preferred deployment, which can differ
            // from the worker serving this browser's existing session.
            val response = window.fetch("/__version", js("({ cache: 'no-store' })")).await()
            if (!response.ok) "" else normalizeBuildDisplay(response.text().await())
        }.getOrDefault("")
    }

    return buildName
}

private fun normalizeBuildDisplay(raw: String): String {
    val clean = raw.trim()
    if (clean.isBlank()) return ""
    if (clean.equals("Entwicklermodus", ignoreCase = true)) return "Entwicklermodus"
    if (clean.startsWith("V ")) return clean

    val version = clean
        .removePrefix("build_")
        .removePrefix("release_")
        .trim()
    return "V $version"
}

fun lumaticaFooterText(activeBuildName: String): String =
    "© 2026 lumatica · by lumatica · Das Netzwerk OS der Logistik" +
        activeBuildName.takeIf { it.isNotBlank() }?.let { " · $it" }.orEmpty()
